import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http, API } from "../lib/api";
import axios from "axios";

const StoreCtx = createContext(null);
export const useStore = () => useContext(StoreCtx);

const CART_KEY = "ss_cart";
const VID_KEY = "ss_vid";

const loadCart = () => {
  try { return JSON.parse(localStorage.getItem(CART_KEY)) || []; } catch { return []; }
};

const visitorId = () => {
  let v = localStorage.getItem(VID_KEY);
  if (!v) { v = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem(VID_KEY, v); }
  return v;
};

export function StoreProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [cart, setCart] = useState(loadCart);
  const [cartOpen, setCartOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [pricing, setPricing] = useState(null);
  const [coupon, setCoupon] = useState("");

  useEffect(() => {
    http.get("/settings").then((r) => {
      setSettings(r.data);
      if (r.data?.accent_color) {
        document.documentElement.style.setProperty("--ss-accent", r.data.accent_color);
      }
    }).catch(() => {});
  }, []);

  useEffect(() => { localStorage.setItem(CART_KEY, JSON.stringify(cart)); }, [cart]);

  const track = useCallback((name, meta = {}) => {
    try {
      axios.post(`${API}/events`, { name, visitor_id: visitorId(), session_id: visitorId(),
        url: window.location.pathname, referrer: document.referrer, ...meta });
    } catch { /* noop */ }
  }, []);

  const recalc = useCallback(async (items, code) => {
    if (!items.length) { setPricing(null); return null; }
    try {
      const r = await http.post("/cart/price", {
        items: items.map((i) => ({ product_id: i.product_id, size: i.size, color: i.color, qty: i.qty })),
        coupon_code: code || null,
      });
      setPricing(r.data);
      return r.data;
    } catch { return null; }
  }, []);

  useEffect(() => { recalc(cart, coupon); /* eslint-disable-next-line */ }, [cart, coupon]);

  const addToCart = (item, openDrawer = true) => {
    setCart((prev) => {
      const idx = prev.findIndex((p) => p.product_id === item.product_id && p.size === item.size && p.color === item.color);
      let next;
      if (idx >= 0) { next = [...prev]; next[idx] = { ...next[idx], qty: next[idx].qty + item.qty }; }
      else next = [...prev, item];
      return next;
    });
    track("add_to_cart", { product_id: item.product_id });
    if (openDrawer) setCartOpen(true);
  };

  const updateQty = (i, qty) => setCart((prev) => prev.map((p, idx) => (idx === i ? { ...p, qty: Math.max(1, qty) } : p)));
  const removeItem = (i) => setCart((prev) => prev.filter((_, idx) => idx !== i));
  const clearCart = () => { setCart([]); setCoupon(""); setPricing(null); };
  const cartCount = cart.reduce((a, b) => a + b.qty, 0);

  return (
    <StoreCtx.Provider value={{
      settings, cart, cartOpen, setCartOpen, searchOpen, setSearchOpen, addToCart, updateQty,
      removeItem, clearCart, cartCount, pricing, recalc, coupon, setCoupon, track,
    }}>
      {children}
    </StoreCtx.Provider>
  );
}
